import React, { useContext, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  Box,
} from "@mui/material";
import { getColors } from "../../themes/theme";
import { useForm } from "react-hook-form";
import { ThemeContext } from "../../context/ThemeContext";
import { isEmail } from "class-validator";

export const EditPracticeDialog = ({ open, onClose, practiceData, onEdit }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      contactname: "",
      practicename: "",
      features: "",
      customerid: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      postalcode: "",
      contactnumber: "",
      email: "",
      blurb: "",
    },
  });

  useEffect(() => {
    if (practiceData) {
      setValue("contactname", practiceData?.contactname);
      setValue("practicename", practiceData?.practicename);
      setValue("features", practiceData?.features);
      setValue("customerid", practiceData?.customerid);
      setValue("address1", practiceData?.address1);
      setValue("address2", practiceData?.address2);
      setValue("city", practiceData?.city);
      setValue("state", practiceData?.state);
      setValue("country", practiceData?.country);
      setValue("postalcode", practiceData?.postalcode);
      setValue("contactnumber", practiceData?.contactnumber);
      setValue("email", practiceData?.email);
      setValue("blurb", practiceData?.blurb);
    }
  }, [practiceData, setValue]);

  const { darkMode } = useContext(ThemeContext);

  const onSave = (data) => {
    onEdit(data);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontSize: "30px", pb: 0 }}>Edit Practice</DialogTitle>

      <form onSubmit={handleSubmit(onSave)}>
        <DialogContent sx={{ pt: 0 }}>
          <Box
            display="grid"
            gridTemplateColumns="repeat(2, 1fr)"
            columnGap={2}
          >
            <FormControl fullWidth margin="normal">
              <TextField
                label="Contact Name"
                placeholder="Enter Contact Name"
                {...register("contactname", {
                  required: "Contact Name is required",
                })}
                error={!!errors.contactname}
                helperText={errors.contactname?.message}
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Practice Name"
                placeholder="Enter Practice Name"
                {...register("practicename", {
                  required: "Practice Name is required",
                })}
                error={!!errors.practicename}
                helperText={errors.practicename?.message}
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Features"
                placeholder="Enter Features"
                {...register("features")}
                error={!!errors.features}
                helperText={errors.features?.message}
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Customer ID"
                placeholder="Enter Customer ID"
                {...register("customerid")}
                error={!!errors.customerid}
                helperText={errors.customerid?.message}
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Address 1"
                placeholder="Enter Address 1"
                {...register("address1")}
                error={!!errors.address1}
                helperText={errors.address1?.message}
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Address 2"
                placeholder="Enter Address 2"
                {...register("address2")}
                error={!!errors.address2}
                helperText={errors.address2?.message}
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="City"
                placeholder="Enter City"
                {...register("city")}
                error={!!errors.city}
                helperText={errors.city?.message}
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="State"
                placeholder="Enter State"
                {...register("state")}
                error={!!errors.state}
                helperText={errors.state?.message}
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Country"
                placeholder="Enter Country"
                {...register("country")}
                error={!!errors.country}
                helperText={errors.country?.message}
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Postal Code"
                placeholder="Enter Postal Code"
                {...register("postalcode")}
                error={!!errors.postalcode}
                helperText={errors.postalcode?.message}
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Contact Number"
                placeholder="Enter Contact Number"
                {...register("contactnumber", {
                  required: "Contact Number is required",
                })}
                error={!!errors.contactnumber}
                helperText={errors.contactnumber?.message}
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Email"
                placeholder="Enter Email"
                {...register("email", {
                  required: "Email is required",
                  validate: (value) =>
                    isEmail(value) || "Please enter a valid email address",
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            </FormControl>
          </Box>

          <FormControl fullWidth margin="normal">
            <TextField
              label="Report Header"
              placeholder="Enter Report Header"
              {...register("blurb")}
              error={!!errors.blurb}
              helperText={errors.blurb?.message}
            />
          </FormControl>

          {/* Frequency Dropdown */}
        </DialogContent>
        <DialogActions sx={{ pt: 0, mr: 2 }}>
          <Button
            sx={{
              borderRadius: "5px",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: 500,
              color: darkMode
                ? getColors.appBarBgLight
                : getColors.appBarBgDark,
              px: 4,
              py: 1,
              textAlign: "center",
              "&: hover": {
                background: "none",
                color: getColors.primaryMain,
              },
            }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              borderRadius: "5px",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: 500,
              px: 5,
              py: 1,
              textAlign: "center",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
